import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

import initReactFastclick from 'react-fastclick'
initReactFastclick()

window.onerror = function(a,b,c){
	alert(JSON.stringify({a:a,b:b,c:c}))
}

// import CachedRef from 'firebase'
 // console.log(CachedRef);
// var url = 'https://xxxx.firebaseio.com/your/url';
// var ref = new CachedRef(url,{
//     timeout: 60000 // timeout before promise rejects 
//     value: null // initial value 
//     key: '...' // key in localStorage 
// })


ReactDOM.render(
  <App />,
  document.getElementById('root')
)


// WEBPACK FOOTER //
// ./src/index.js